const initialState = {
  isLoading: false,
  isError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'IS_SUCCESS':
      return {
        ...state,
        isError: action.payload
      };
    case 'IS_ERROR':
      return {
        ...state,
        isError: action.payload
      };
    case 'IS_LOADING':
      return {
        ...state,
        isLoading: action.payload
      };
    default:
      return state;
  }
};
